import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex pt-3"
}
const _hoisted_2 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_3 = {
  id: "eye-icon-wrapper",
  class: "d-flex"
}
const _hoisted_4 = {
  key: 1,
  class: "ml-2 pt-2"
}

import { ref, computed, watch } from "vue"
import { generatePassword } from "@/services/functions"
import PasswordGenerate from "@/components/AccountParts/PasswordGenerate.vue"
import FormRow from "@/components/Common/FormRow.vue"
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordForm',
  props: {
    title: {},
    modelValue: {},
    maskable: { type: Boolean, default: false },
    accountId: {},
    isDriverMode: { type: Boolean, default: false },
    errors: {},
    driverId: {}
  },
  emits: ['update:modelValue', 'error', 'emptyError'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props
const textType = ref("password")
const passwordMask = ref(true)
const isShowPasswordTextBox = ref(false)
const passwordSettingButtonName = i18n.global.t('pages.accounts.form.button.passwordSetting');
const autoGenerateButtonName = i18n.global.t('pages.accounts.form.button.passwordAutoGenerate');
const errorsArray = ref([] as string[])

const isShowTextBox = computed(() => {
  return isShowPasswordTextBox.value || props.maskable || !props.accountId
})

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

function showPassword () {
  passwordMask.value = false
  textType.value = "text"
}

function maskPassword() {
  passwordMask.value = true
  textType.value = "password"
}

function showPasswordTextBox(bool: boolean) {
  isShowPasswordTextBox.value = bool
  modelValue.value = ""
}

function displayError(errors: string[]) {
  if (!errors.length) isShowPasswordTextBox.value = true
  errorsArray.value = errors
}

watch(() => props.errors, (value) => {
  errorsArray.value = value
})

watch(() => props.isDriverMode, (bool) => {
  if(!props.accountId && bool && props.driverId) emits("update:modelValue", generatePassword(props.driverId))
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(FormRow, {
    title: props.title
  }, {
    default: _withCtx(() => [
      (!isShowTextBox.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_btn, {
              class: "exec-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showPasswordTextBox(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(passwordSettingButtonName)), 1)
              ]),
              _: 1
            }),
            _createVNode(PasswordGenerate, {
              class: "ml-2",
              buttonName: _unref(autoGenerateButtonName),
              driverId: props.driverId,
              modelValue: modelValue.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event)),
              onDisplayError: displayError
            }, null, 8, ["buttonName", "driverId", "modelValue"])
          ]))
        : _createCommentVNode("", true),
      (isShowTextBox.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_text_field, {
              "hide-details": "auto",
              class: "small pt-2",
              modelValue: modelValue.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
              type: textType.value,
              density: "compact",
              "error-messages": errorsArray.value,
              clearable: false
            }, {
              "append-inner": _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _withDirectives((_openBlock(), _createElementBlock("svg", {
                    onClick: maskPassword,
                    viewBox: "0 0 576 512"
                  }, [...(_cache[5] || (_cache[5] = [
                    _createElementVNode("path", { d: "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" }, null, -1)
                  ]))], 512)), [
                    [_vShow, !passwordMask.value]
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("svg", {
                    onClick: showPassword,
                    viewBox: "0 0 640 512"
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("path", { d: "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.6 386.7c39.6-40.6 66.4-86.1 79.9-118.4c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-68.2 0-125 26.3-169.3 60.8L38.8 5.1zM223.1 149.5C248.6 126.2 282.7 112 320 112c79.5 0 144 64.5 144 144c0 24.9-6.3 48.3-17.4 68.7L408 294.5c5.2-11.8 8-24.8 8-38.5c0-53-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6c0 10.2-2.4 19.8-6.6 28.3l-90.3-70.8zm223.1 298L373 389.9c-16.4 6.5-34.3 10.1-53 10.1c-79.5 0-144-64.5-144-144c0-6.9 .5-13.6 1.4-20.2L83.1 161.5C60.3 191.2 44 220.8 34.5 243.7c-3.3 7.9-3.3 16.7 0 24.6c14.9 35.7 46.2 87.7 93 131.1C174.5 443.2 239.2 480 320 480c47.8 0 89.9-12.9 126.2-32.5z" }, null, -1)
                  ]))], 512)), [
                    [_vShow, passwordMask.value]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "type", "error-messages"]),
            (!props.maskable)
              ? (_openBlock(), _createBlock(PasswordGenerate, {
                  key: 0,
                  class: "ml-4 mt-2",
                  buttonName: _unref(autoGenerateButtonName),
                  driverId: props.driverId,
                  modelValue: modelValue.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modelValue).value = $event)),
                  onDisplayError: displayError
                }, null, 8, ["buttonName", "driverId", "modelValue"]))
              : _createCommentVNode("", true),
            (!props.maskable && props.accountId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_v_btn, {
                    class: "reset-btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showPasswordTextBox(false)))
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                      _createTextVNode(" キャンセル ", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})